import Mutations from '../../odata/mutations';

export default { ...new Mutations('category'), ...new Mutations('categories') };
